import {useQuery} from '@tanstack/react-query';
import {jwtDecode} from 'jwt-decode';
import {fetchOperatorProfileApi, fetchAdminProfileApi} from './header-api'; // adjust path if needed

/**
 * A supervisor has no operator profile and no admin profile — by design; they are an identity with
 * oversight, not a row in either table. So there is no endpoint to ask, and asking /operator/profile
 * would answer 403 and leave the header nameless.
 *
 * The name is already in the access token (the `name` claim, set at sign-in), so it is read from
 * there rather than inventing a profile endpoint for a profile that does not exist.
 */
function selfFromToken() {
    try {
        const claims = jwtDecode(localStorage.getItem('access-token'));
        return {fullName: claims?.name || '', email: claims?.sub || ''};
    } catch (e) {
        return {fullName: '', email: ''};
    }
}

export function useSelfProfile() {
    const role = localStorage.getItem("role") || 'OPERATOR';

    const queryFn =
        role === "ADMIN"
            ? fetchAdminProfileApi
            : role === "SUPERVISOR"
                ? async () => selfFromToken()
                : fetchOperatorProfileApi;

    return useQuery({
        queryKey: ["user", "profile", role],
        queryFn,
        refetchOnWindowFocus: true,
        staleTime: 30 * 1000,
    });
}